import { useState } from "react";
import api from "@/lib/api";
import { useTier } from "@/context/TierContext";
import { Sparkles, Loader2 } from "lucide-react";

// Subtle countdown banner for users on an active TenantSeal Plus trial.
export function TrialBanner() {
  const { trialing, trialEnd } = useTier() || {};
  const [busy, setBusy] = useState(false);
  if (!trialing || !trialEnd) return null;

  const ms = new Date(trialEnd).getTime() - Date.now();
  const days = Math.max(0, Math.ceil(ms / 86400000));
  const daysLabel = days === 1 ? "1 day" : `${days} days`;

  const openPortal = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/billing/create-portal-session", { origin: window.location.origin });
      window.location.href = data.portal_url;
    } catch {
      setBusy(false);
    }
  };

  return (
    <div data-testid="trial-banner"
      className="mb-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 rounded-xl border border-[#BFDBFE] bg-[#EFF6FF] px-4 py-3">
      <Sparkles size={16} className="text-brand shrink-0" />
      <p className="text-sm text-[#1E3A5F] flex-1" data-testid="trial-banner-text">
        Your TenantSeal Plus trial ends in <b>{daysLabel}</b>. You can manage or cancel anytime.
      </p>
      <button data-testid="trial-banner-manage-btn" onClick={openPortal} disabled={busy}
        className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-navy hover:bg-navy-hover text-white text-xs font-semibold px-3.5 py-2 transition-colors disabled:opacity-60 self-start sm:self-auto shrink-0">
        {busy && <Loader2 size={13} className="animate-spin" />} Manage billing
      </button>
    </div>
  );
}
